import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      minHeight: 200
    },
    formControl: {
      margin: theme.spacing(1)
    },
    tableHeader: {
      background: colors.defaultGrey,
      position: 'sticky',
      top: 0,
      zIndex: 10
    },
    loadBtnGrid: {
      textAlign: 'right'
    },
    collapseCell: {
      paddingBottom: 0,
      paddingTop: 0
    },
    detailsContainer: {
      padding: theme.spacing(2)
    }
  })
);
